<template>
  <div class="item_conten">
    <div 
      class="item_text" 
      v-for="(item, index) in listData" 
      :key="index" 
      @click="$emit('item-click', item)"
    >
      {{ item.title }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'newsList2',
  props: {
    // 列表数据
    listData: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped lang="scss">
.item_conten {
  width: 100%;
  height: calc(100% - 40px);
  padding: 10px 10px 0px 20px;

  .item_text {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    height: 34px;
    line-height: 34px;
    cursor: pointer;
    
    &:hover {
      color: #5cb85c;
      text-decoration: underline;
    }
  }
}
</style>